module.exports = __webpack_public_path__ + "img/portfolio_nav_dark.f0eb2028.svg";